import i18n from "i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import moment from "moment";
import "moment/locale/fr";
import { registerLocale, setDefaultLocale } from "react-datepicker";
import { fr } from "date-fns/locale/fr";
import { enGB } from "date-fns/locale/en-GB";
registerLocale("fr", fr);
registerLocale("en-GB", enGB);

export const SUPPORTED_LANGUAGES = {
  "en-GB": { name: "en-GB", nativeName: "English", flag: "🇬🇧" },
  fr: { name: "fr-FR", nativeName: "Français", flag: "🇫🇷" },
} as const;

export type SupportedLanguage = keyof typeof SUPPORTED_LANGUAGES;

// TEMPORARY (this release only): multilingual support ships hidden.
// Forces English everywhere and hides the language switcher.
// Revert by setting this back to `true` when French officially launches.
export const MULTILINGUAL_ENABLED = false;

export const DEFAULT_LANGUAGE: SupportedLanguage = "en-GB";
export const FALLBACK_LANGUAGE: SupportedLanguage = "en-GB";

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: DEFAULT_LANGUAGE,
    fallbackLng: FALLBACK_LANGUAGE,
    nsSeparator: false,
    keySeparator: false,
    backend: {
      loadPath: (lng: string[]) => {
        const language = lng[0];
        if (language === "fr") return "/locales/fr-FR/fr.json";
        return "/locales/en-GB/en.json";
      },
    },
    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      caches: ["localStorage"],
      lookupLocalStorage: "i18nextLng",
    },
    react: {
      useSuspense: true,
    },
  });

i18n.on("languageChanged", (lng: string) => {
  document.documentElement.lang = lng;
  moment.locale(lng);
  setDefaultLocale(lng);
});

export default i18n;
